if (!customElements.get('price-slider')) {
  customElements.define(
    'price-slider',
    class PriceSlider extends HTMLElement {
      connectedCallback() {
        this.ranges = [...this.querySelectorAll('input[type="range"]')];
        this.fields = [...this.nextElementSibling.querySelectorAll('input')];
        this.currency = this.querySelector('[data-price-min]').textContent.replace(/[\d.,\s]/g, '');
        this.ranges.forEach((range) => range.addEventListener('input', () => this.update(range)));
        this.paint();
      }

      update(moved) {
        const [min, max] = this.ranges;
        if (Number(min.value) > Number(max.value)) moved.value = moved === min ? max.value : min.value;
        this.fields[0].value = Number(min.value) > 0 ? min.value : '';
        this.fields[1].value = Number(max.value) < Number(max.max) ? max.value : '';
        this.paint();
      }

      paint() {
        const [min, max] = this.ranges;
        const top = Number(max.max) || 1;
        this.style.setProperty('--from', `${(min.value / top) * 100}%`);
        this.style.setProperty('--to', `${(max.value / top) * 100}%`);
        this.querySelector('[data-price-min]').textContent = `${this.currency}${min.value}`;
        this.querySelector('[data-price-max]').textContent = `${this.currency}${max.value}`;
      }
    }
  );
}
